import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Button from '../Button';
import './styles.scss';

class DatePicker extends Component {
  static daysForMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  static months = [
    'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September',
    'October', 'November', 'December',
  ];

  static propTypes = {
    onChange: PropTypes.func.isRequired,
    defaultValue: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.state = {
      editing: true,
    };
  }

  getDate() {
    if (!this.props.defaultValue) {
      const today = new Date();

      return {
        month: today.getMonth() + 1,
        day: today.getDate(),
      };
    } else {
      const splitDate = this.props.defaultValue.split('-');

      return {month: splitDate[1], day: splitDate[2]};
    }
  }

  handleEdit = () =>
    this.setState({editing: true})

  handleSave = (e) => {

    const month = this.month.value;
    const day = this.day.value;

    if (day <= 0 || day > DatePicker.daysForMonth[month - 1]) {
      this.day.setCustomValidity('Invalid day for month');
      this.day.checkValidity();
    } else {
      this.props.onChange(`2017-${month}-${day}`);
    }
    e.preventDefault();
  }

  render() {
    const {month, day} = this.getDate();

    if (this.state.editing) {
      return (
        <form className="date-picker editing">
          <input type="text" min={0} max={31} name="day" id="day" ref={(input) => this.day = input}
                 defaultValue={day} onChange = {this.handleSave}/>
          <select onChange = {this.handleSave} name="month" id="month" ref={(input) => this.month = input}
                  defaultValue={parseInt(month, 10)}>
            {DatePicker.months.map((month, idx) =>
              <option value={idx + 1} key={idx + 1}>{month}</option>,
            )}
          </select>
        </form>
      );
    } else {
      return (
        <div className="date-picker" onDoubleClick={this.handleEdit}>
          {day}&nbsp;{DatePicker.months[month - 1]}
        </div>
      );
    }
  }
}

export default DatePicker;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/widgets/DatePicker/index.js